import React from "react";
import Dropdown from "../../Components/Dropdown/Dropdown";

function FAQ(props) {
  return (
    <a href id="faq">
      <h1 className="text-transparent tracking-tight letter-spacing:-0.05em text-center text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] pb-3 pt-1 bg-clip-text mb-5  font-bold bg-gradient-to-r from-[#8926B6] to-[#EABCFF]">
        Frequently Asked Questions
      </h1>
      <div className="flex justify-center md:w-6/12 lg:w-5/12 2xl:w-5/12 md:px-[70px] px-10 m-auto flex-col bg-[#121127] p-10 mt-10 mb-[200px] 2xl:px-[90px]">
        <Dropdown title={" Where can I get my NFT ?"} detail={"Opensea.io"} />
        <Dropdown
          title={" How can I join the presale list ?"}
          detail={"Join our discord community for info"}
        />
        <Dropdown
          title={" How many handitars can I mint ?"}
          detail={"Join our discord community for info"}
        />

        <Dropdown
          title={" When is the launch date ?"}
          detail={"Coming Soon"}
        />
      </div>
    </a>
  );
}

export default FAQ;
